import type { AxiosResponse } from "axios";
import createAppAsyncThunk from "./createAppAsyncThunk";

type AppDispatch = (action: unknown) => unknown;

interface WriteHandlers<Arg, Data> {
  request(arg: Arg): Promise<AxiosResponse<Data>>;
  onSuccess(dispatch: AppDispatch, data: Data, arg: Arg): unknown;
}

/**
 * The add/update/patch shape SCRUM-2119's census grouped: call the API, dispatch
 * the legacy success action, then the refetch. The error hub is
 * createAppAsyncThunk's, so none of these write their own GET_ERRORS.
 *
 * `onSuccess` runs only after the request resolves. A throw never reaches it.
 */
export function apiWriteThunk<Arg, Data>(
  typePrefix: string,
  request: WriteHandlers<Arg, Data>["request"],
  onSuccess: WriteHandlers<Arg, Data>["onSuccess"]
) {
  return createAppAsyncThunk(typePrefix, async (arg: Arg, thunkAPI) => {
    const res = await request(arg);
    await onSuccess(thunkAPI.dispatch, res.data, arg);
    return res.data;
  });
}
